
import React from 'react';
import { Building, Home, MapPin, Ruler, Wrench } from 'lucide-react';

const ServiceAreaStats = () => {
  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Serving Eastern North Carolina</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Carolina Trophy Roofs provides premium roofing services across 70+ communities in Eastern NC, 
            with dedicated teams based in Rocky Mount, Greenville, and Tarboro.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="bg-gray-50 p-6 rounded-lg text-center">
            <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
              <MapPin className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-3xl font-bold mb-2">70+</h3>
            <p className="text-gray-600">Towns & Cities Served</p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg text-center">
            <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
              <Building className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-3xl font-bold mb-2">3</h3>
            <p className="text-gray-600">Office Locations</p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg text-center">
            <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
              <Home className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-3xl font-bold mb-2">5,000+</h3>
            <p className="text-gray-600">Roofs Completed</p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg text-center">
            <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
              <Ruler className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-3xl font-bold mb-2">150+ mi</h3>
            <p className="text-gray-600">Service Radius</p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg text-center">
            <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
              <Wrench className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-3xl font-bold mb-2">30+</h3>
            <p className="text-gray-600">Specialized Services</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaStats;
